const envConfig = {
  endpoint: 'https://api.sobrerodas.club/',
  endpointv2: 'https://api.sobrerodas.club/v2/',
};

export default envConfig;
